import {Component, inject, OnDestroy, OnInit, Signal} from '@angular/core';
import {
  ApplicantAddressDataFormComponent
} from "../../../common/applicant-data-section/components/applicant-address-data-form/applicant-address-data-form.component";
import {CommonModule} from "@angular/common";
import {NgxMaskDirective} from "ngx-mask";
import {
  ProxyFormComponent
} from "../../../common/applicant-data-section/components/proxy-person-form/proxy-form.component";
import {ReactiveFormsModule} from "@angular/forms";
import {RouterLink} from "@angular/router";
import {SpinnerComponent} from "../../../../../../common/spinner/spinner.component";
import {StagesComponent} from "../../../../../../common/stages/stages.component";
import {ValidationErrorsComponent} from "../../../../../../common/validation-errors/validation-errors.component";
import {ApplicantForm} from "../../../common/applicant-data-section/forms/applicant.form";
import {UserDetails} from "../../../../../../store/reducers/user-details.reducer";
import {selectUser} from "../../../../../../store/selectors/user-details.selectors";
import {toObservable} from "@angular/core/rxjs-interop";
import {SessionService} from "../../../../../../services/ssession.service";
import {
  createApplication,
  updateApplicantData,
  updateApplication
} from "../../../../../../store/actions/application.actions";
import {EntityType} from "../../../../../../pipes/entity-type.pipe";
import {stages} from "../../contact-data-update.routes";
import {ApplicationCommonComponent} from "../../../common/application.common.component";

@Component({
  selector: 'app-contact-data-update-applicant-section',
  standalone: true,
  imports: [
    ApplicantAddressDataFormComponent,
    CommonModule,
    NgxMaskDirective,
    ProxyFormComponent,
    ReactiveFormsModule,
    RouterLink,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [
    ApplicantForm
  ],
  templateUrl: './contact-data-update-applicant-section.component.html'
})
export class ContactDataUpdateApplicantSectionComponent extends ApplicationCommonComponent implements OnInit, OnDestroy {
  public stages: string[] = stages;

  public form: ApplicantForm = inject(ApplicantForm);

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  private fetchApplicant = toObservable(this.application).subscribe((data) => {
    this.form.patchFormValues(data);
  });

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.store$.dispatch(updateApplication({
          id: this.applicationId || '',
          application: {},
          successFnc: (application) => {
            this.updateApplicantData(application?.uuid || '');
          },
          failureFnc: () => {
          }
        }));
      } else {
        this.store$.dispatch(createApplication({
          serviceTypeId: this.serviceType()?.uuid || '',
          application: {},
          successFnc: (application) => {
            this.updateApplicantData(application?.uuid || '');
          },
          failureFnc: () => {
          }
        }));
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  private updateApplicantData(appId: string): void {
    this.store$.dispatch(updateApplicantData({
      application: {
        uuid: appId
      },
      applicationPayload: {
        isFiledByProxy: this.form.isFiledByProxy.value,
        ...this.form.proxyPersonForm?.toWriteModel()
      },
      applicantPayload: this.form.toWriteModel(),
      successFnc: (applicationId) => {
        this.router.navigate(
          [this.applicationId ? `../../${this.applicationId}/` : `../${appId}/`, 'adres-zamieszkania'],
          {
            relativeTo: this.route
          }
        );
      },
      failureFnc: () => {
      }
    }));
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.form?.entityType?.setValue(EntityType.OSOBA_FIZYCZNA);
    this.form.identifierType.setValue('PESEL');
    this.form?.nip.disable();
    this.form?.regon.disable();
    this.form?.name.disable();

    this.form?.fatherName.disable();
    this.form?.motherName.disable();
    this.form?.birthDate.disable();

    this.form?.firstName.enable();
    this.form?.lastName.enable();
    this.form?.pesel.enable();
  }

  public override ngOnDestroy() {
    super.ngOnDestroy();
    this.fetchApplicant.unsubscribe();
  }
}
